<template>
    <div class="contain_box">
        <div class="head_title">
            <div class="left_title">
                <div class="pic_box"></div>
                <div class="data_box">
                    <p>{{this.videoData.nickname}}</p>
                    <p>{{this.videoData.follower_count}}粉丝</p>
                </div>
            </div>
            <div class="right_title">
                <div class="box1">
                    <p>总点赞</p>
                    <p style="text-align: center">{{this.videoData1.digg_count}}</p>
                </div>
                <div class="divider"></div>
                <div class="box1">
                    <p>总评论</p>
                    <p style="text-align: center">{{this.videoData1.comment_count}}</p>
                </div>
                <div class="divider"></div>
                <div class="box1">
                    <p>总转发</p>
                    <p style="text-align: center">{{this.videoData1.share_count}}</p>
                </div>
            </div>
        </div>
        <div class="middle_box">
            <div style="margin-left: 40px;">热门评论({{this.tableData.length}})</div>
        </div>
        <div class="main_box">
            <el-table
                    :show-header="false"
                    :data="tableData"
                    style="width: 100%;">
                <el-table-column prop="text" label="评论">
                    <template slot-scope="scope">
                        <p class="student-name-title">{{scope.row.text}}</p>
                        <p style="font-size:14px;font-weight:400;color:rgba(153,153,153,1);"
                           class="student-name-title">
                            {{scope.row.create_time}}</p>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" prop="digg_count" label="点赞" width="180">
                    <template slot-scope="scope">
                        <div style="display: flex;">
                            <i class="iconfont">&#xe85c;</i>
                            <span style="margin-left: 5px"
                                  class="student-name-title">{{scope.row.digg_count}}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["aweme_id"],
        data() {
            return {
                videoData: {},
                videoData1: {},
                tableData: [],
                id: "",
            }
        },
        created() {
            if (this.$route.query.aweme_id != "") {
                this.id = this.$route.query.aweme_id;
            }
            this.getVideoDetail();
        },
        methods: {
            getVideoDetail() {
                let param = {
                    aweme_id: this.aweme_id ? this.aweme_id : this.id,
                };
                this.$httpStudent.axiosGetBy(this.$api.hotPeopleVideoDetails, param, res => {
                    if (res.code == 200) {
                        this.videoData = res.data.video_details.author;
                        this.videoData1 = res.data.video_details.aweme;
                        if (res.data.video_comments) {
                            this.tableData = res.data.video_comments;
                        }
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg,
                            duration: 1000
                        });
                    }
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .contain_box {
        height: 100%;

        .head_title {
            height: 80px;
            display: flex;
            justify-content: space-between;

            .left_title {
                margin-left: 40px;
            }

            .right_title {
                margin-right: 40px;
                display: flex;

                .divider {
                    background-color: #DCDFE6;
                    display: inline-block;
                    width: 1px;
                    height: 3em;
                    margin-top: 18px;
                    margin-right: 8px;
                    margin-left: 8px;
                    vertical-align: middle;
                    position: relative;
                }
            }
        }

        .middle_box {
            padding-top: 40px;
        }

        .main_box {
            padding-top: 20px;
            margin-left: 40px;
        }
    }
</style>